import React, { RefObject, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@b_v/components';
import { Button } from '@bice_vida/ds-components-button';
import { PlanT } from '@csi-monorepo/core/domain/insurance';
import PlanNameEnum from '@csi-monorepo/core/enums/planNames';
import { FullModalContext } from '@src/components/Header/FullModalContext';
import { COVERAGE_TABS } from '@src/constants/planCoverages';
import { AdditionalAssistEnum } from '@src/enums/additionalAssistsEnum';
import findAdditionalCoverages from '@src/libs/findPlanWithAssists';
import useAppStore from '@src/stores/useAppStore';
import Image from 'next/image';

import styles from './LandingBenefitsAssists.module.scss';

type LandingBenefitsAssistsPropsT = {
  scrollRef?: RefObject<HTMLDivElement>;
};

const LandingBenefitsAssists: React.FC<LandingBenefitsAssistsPropsT> = ({ scrollRef }) => {
  const { t } = useTranslation();
  const { onOpenModalHandler } = useContext(FullModalContext);
  const { insurance } = useAppStore();
  const [additionalAssists, setAdditionalAssists] = useState<string[]>([]);

  const onClickButton = () => {
    onOpenModalHandler(
      insurance?.plans?.find((plan: PlanT) => plan?.name === PlanNameEnum.elite)?.id as number,
      COVERAGE_TABS.additional
    );
  };

  useEffect(() => {
    setAdditionalAssists(findAdditionalCoverages(insurance?.plans) || []);
  }, [insurance?.plans]);

  return (
    <>
      {additionalAssists?.filter(
        (assist) =>
          assist === AdditionalAssistEnum.dentalAssists ||
          assist === AdditionalAssistEnum.petAssists
      ).length > 0 && (
        <div ref={scrollRef} className={styles.LandingBenefitsElite}>
          <Text tag="h2" className={styles.LandingBenefitsElite__title}>
            {t('BENEFITS_EXCLUSIVE_ELITE_1')}
            <span className={styles.LandingBenefitsElite__blue}>
              {t('BENEFITS_EXCLUSIVE_ELITE_2')}
            </span>
          </Text>

          <div className={styles.LandingBenefitsElite__body}>
            {additionalAssists.includes(AdditionalAssistEnum.dentalAssists) && (
              <div className={styles.LandingBenefitsElite__body__card}>
                <div className={styles.LandingBenefitsElite__body__card__icon}>
                  <Image
                    src={`/images/benefits/assists_dental.webp`}
                    alt=""
                    width={64}
                    height={64}
                  />
                </div>
                <div className={styles.LandingBenefitsElite__body__card__info}>
                  <Text tag="p" className={styles.LandingBenefitsElite__body__card__info__title}>
                    {t('BENEFITS_EXCLUSIVE_ELITE_CARD_1_TITLE')}
                  </Text>
                  <Text tag="p" className={styles.LandingBenefitsElite__body__card__info__text}>
                    {t('BENEFITS_EXCLUSIVE_ELITE_CARD_1_TEXT')}
                  </Text>
                </div>
              </div>
            )}
            {additionalAssists.includes(AdditionalAssistEnum.petAssists) && (
              <div className={styles.LandingBenefitsElite__body__card}>
                <div className={styles.LandingBenefitsElite__body__card__icon}>
                  <Image src={`/images/benefits/assists_pets.webp`} alt="" width={64} height={64} />
                </div>
                <div className={styles.LandingBenefitsElite__body__card__info}>
                  <Text tag="p" className={styles.LandingBenefitsElite__body__card__info__title}>
                    {t('BENEFITS_EXCLUSIVE_ELITE_CARD_2_TITLE')}
                  </Text>
                  <Text tag="p" className={styles.LandingBenefitsElite__body__card__info__text}>
                    {t('BENEFITS_EXCLUSIVE_ELITE_CARD_2_TEXT')}
                  </Text>
                </div>
              </div>
            )}
          </div>
          <Button
            variant="secondary"
            size="l"
            className={styles.LandingBenefitsElite__button}
            onClick={onClickButton}
          >
            {t('BENEFITS_EXCLUSIVE_ELITE_BUTTON')}
          </Button>
        </div>
      )}
    </>
  );
};

export default LandingBenefitsAssists;
